import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import Chart from 'chart.js';
import { takeUntil, finalize, Subject } from 'rxjs';
import { BackendAccessService } from '../../../Services/APICalls/backend-access-service';
import { LoadingService } from '../../../Services/Loading/loading-service.service';
import { BranchSelectionService } from '../../../Services/branch-selection.service';

@Component({
    selector: 'app-apidetails-dialog-component',
    templateUrl: './apidetails-dialog-component.component.html',
    styleUrls: ['./apidetails-dialog-component.component.scss'],
    standalone: false
})
export class APIDetailsDialogComponentComponent {
  private chart: Chart | null = null;
  integrationName: string | null = null;
  productType: string | null = null;
  anniversaryDate: string | null = null;
  totalActiveCredentials: number | null = null;
  chartData: { label: string; value: number }[] = [];
  private destroy$ = new Subject<void>();
  branchId: string | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute,
    public backend: BackendAccessService,
    public datePipe: DatePipe,
    private branchSelectionService: BranchSelectionService,
    private loadingService: LoadingService
  ) {}

  //   ngOnInit() {
  //     this.route.queryParams.subscribe((params) => {
  //       console.log('Query Params:', params);
  //       this.integrationName = params['integrationName'];
  //       this.productType = params['productType'];
  //       this.totalActiveCredentials = params['totalActiveCredentials'];
  //       this.branchId! = params['branchId'];
  //     });

  //     // Listen for branch selections
  //     this.branchSelectionService.selectedBranch$
  //       .pipe(takeUntil(this.destroy$))
  //       .subscribe((selectedBranch) => {
  //         console.log('Selected branch:', selectedBranch);
  //         // If a branch is explicitly selected, use it
  //         if (selectedBranch) {
  //           this.loadAPICredentialDetails(selectedBranch);
  //         } else {
  //           // Otherwise, use the branchId from the queryParams if available
  //           this.branchId !== null &&
  //             this.loadAPICredentialDetails(this.branchId);
  //         }
  //       });

  //     // If there's a branchId in queryParams and no branch is selected initially, load details for it
  //     if (
  //       this.branchId !== null &&
  //       !this.branchSelectionService.getSelectedBranch()
  //     ) {
  //       this.loadAPICredentialDetails(this.branchId);
  //       console.log('hit this');
  //     }
  //   }

  //   loadAPICredentialDetails(branchId?: string) {
  //     // If no branchId is provided, try getting the selected branch
  //     const effectiveBranchId =
  //       branchId || this.branchSelectionService.getSelectedBranch();
  //     if (!effectiveBranchId) {
  //       console.error('No branchId provided and no branch selected.');
  //       return;
  //     }
  //     this.loadingService.show();

  //     // The rest of the API call logic now uses effectiveBranchId
  //     const integrationId = this.route.snapshot.paramMap.get('integrationId');
  //     const skuCode = this.route.snapshot.queryParamMap.get('skuCode');

  //     if (integrationId && skuCode) {
  //       this.backend
  //         .getAPICredentialDetailsData(integrationId, skuCode, effectiveBranchId)
  //         .pipe(finalize(() => this.loadingService.hide()))
  //         .subscribe(
  //           (data) => {
  //             console.log('API Details Data', data);
  //             this.anniversaryDate = data.anniversaryDate;
  //             this.chartData = data.monthlyData.map((item: any) => ({
  //               label: `${item.createdMonth} ${item.createdYear}`,
  //               value: item.totalActiveCredentials,
  //             }));
  //             this.createChart();
  //           },
  //           (error) => {
  //             console.error('Error fetching API details data:', error);
  //           }
  //         );
  //     } else {
  //       console.error(
  //         'Integration ID or SKU Code is missing from the route parameters.'
  //       );
  //     }
  //   }

  //   ngAfterViewInit() {
  //     window.addEventListener('resize', this.handleResize);
  //   }

  //   ngOnDestroy() {
  //     window.removeEventListener('resize', this.handleResize);
  //     this.destroy$.next();
  //     this.destroy$.complete();
  //   }

  //   handleResize() {
  //     if (this.chart) {
  //       this.chart.resize();
  //     }
  //   }

  //   createChart() {
  //     const canvas = document.getElementById('APIChart') as HTMLCanvasElement;
  //     if (!canvas) return;

  //     const ctx = canvas.getContext('2d');
  //     if (!ctx) return;

  //     const labels = this.chartData.map((dataItem) => dataItem.label);
  //     const singleMonth = labels.length === 1;

  //     this.chart = new Chart(ctx, {
  //       type: 'line',

  //       data: {
  //         labels: singleMonth ? ['', ...labels, ''] : [...labels],
  //         datasets: [
  //           {
  //             label: 'Number of Active Credentials',
  //             data: singleMonth
  //               ? [0, ...this.chartData.map((dataItem) => dataItem.value)]
  //               : [...this.chartData.map((dataItem) => dataItem.value)],
  //             backgroundColor: 'rgba(29, 78, 216, 0.2)',
  //             borderColor: 'rgba(29, 78, 216, 2)',
  //             borderWidth: 2,
  //           },
  //         ],
  //       },
  //       options: {
  //         responsive: true,
  //         maintainAspectRatio: false,
  //         scales: {
  //           yAxes: [
  //             {
  //               ticks: {
  //                 beginAtZero: true,
  //               },
  //             },
  //           ],
  //         },
  //       },
  //     });
  //   }
  // }
  ngOnInit() {
    this.loadAPICredentialDetails();
  }

  loadAPICredentialDetails() {
    if (!this.data.integrationId || !this.data.skuCode) {
      console.error('Integration ID or SKU Code is missing.');
      return;
    }
    this.loadingService.show();
    this.integrationName = this.data.integrationName;
    this.totalActiveCredentials = this.data.totalActiveCredentials;
    this.productType = this.data.productType;

    this.backend
      .getAPICredentialDetailsData(
        this.data.integrationId,
        this.data.skuCode,
        this.data.branchId
      )
      .subscribe(
        (data) => {
          console.log('API Details Data', data);
          this.anniversaryDate = data.anniversaryDate;
          this.chartData = data.monthlyData.map((item: any) => ({
            label: `${item.createdMonth} ${item.createdYear}`,
            value: item.totalActiveCredentials,
          }));

          // Now that chartData is updated, create the chart
          this.createChart();
        },
        (error) => {
          console.error('Error fetching API details data:', error);
        }
      )
      .add(() => this.loadingService.hide()); // Ensure loading indicator is hidden afterwards
  }

  createChart() {
    const canvas = document.getElementById('APIChart') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const labels = this.chartData.map((dataItem) => dataItem.label);
    const singleMonth = labels.length === 1;

    this.chart = new Chart(ctx, {
      type: 'line',

      data: {
        labels: singleMonth ? ['', ...labels, ''] : [...labels],
        datasets: [
          {
            label: 'Number of Active Credentials',
            data: singleMonth
              ? [0, ...this.chartData.map((dataItem) => dataItem.value)]
              : [...this.chartData.map((dataItem) => dataItem.value)],
            backgroundColor: 'rgba(29, 78, 216, 0.2)',
            borderColor: 'rgba(29, 78, 216, 2)',
            borderWidth: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    });
  }
}
